module.exports = __webpack_public_path__ + "static/media/exe.2277dc01.svg";